

























































































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ContactForm extends Vue {
  public isLoading = false;

  public error = false;

  public showForm = true;

  public a = Math.floor(Math.random() * 10);

  public b = Math.floor(Math.random() * 10);

  public questionValue: number | null = null;

  public form: { [key: string]: string | null} = {
    email: null,
    name: null,
    message: null,
  } ;

  public get isDisabled() {
    return !this.form.email
      || !this.form.name
      || !this.form.message
      || !this.validationEmail
      || !this.validationName
      || !this.validationMessage
      || !this.validationQuestion;
  }

  public get validationEmail() {
    // eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return this.form.email && re.test(String(this.form.email).toLowerCase());
  }

  public get validationName() {
    return this.form.name && this.form.name.length > 3;
  }

  public get validationMessage() {
    return this.form.message && this.form.message.length > 15;
  }

  public get validationQuestion() {
    return this.questionValue && Number(this.questionValue) === (this.a + this.b);
  }

  public async onSubmit(event: Event) {
    event.preventDefault();
    const url = './.netlify/functions/send';
    const content = {
      Message:
        {
          From: {
            Email: 'noreply@pcszervizszentes.hu',
            Name: 'PC Szerviz Szentes',
          },
          To:
            {
              Email: 'pcszervizszentes@gmail.com',
              Name: 'PC Szerviz Szentes',
            },
          Subject: '[PCSZERVIZ] Egy új értesítés az oldalról!',
          TextPart: `${this.form.message}\n Az üzenet feladója: ${this.form.name} - ${this.form.email}`,
          HTMLPart: `${this.form.message} <br> Az üzenet feladója: <br> ${this.form.name} - ${this.form.email}`,
        },
    };
    this.isLoading = true;
    this.showForm = false;
    try {
      await fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(content),
      }).then((response: {status: number}) => {
        this.isLoading = false;
        this.showForm = false;
        if (response.status !== 200) this.error = true;
      });
    } catch (error) {
      this.error = true;
    }
  }
}
